module.exports = __webpack_public_path__ + "static/media/E8D28DDC-7DFA-4A33-8AAA-631DC5136ECC.ee818f31.bin";